import { useParams, Navigate, Outlet } from 'react-router-dom';

export default function EnhancementRoutesWithFileContext() {
  const { fileId } = useParams();

  if (!fileId) {
    console.log('navigating');
    return <Navigate to="../" />;
  }

  return <Outlet />;
}
